import { doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { todayKey } from "../../shared/dates";

// Today's Reminders is folded only on the day it was folded (Craig, 24 Oct 2026: "expanded by default, but remember
// the user's last state each day"). The day is stored, not a yes or no, so the card opens on a new day even if the
// app stayed open past midnight and is still showing yesterday's document.
export const remindersOpen = (dayData, today = todayKey()) => dayData?.remindersFoldedOn !== today;

// Saves the fold on today's document; returns the write's promise so a failure can be undone on screen.
export const setRemindersFolded = (uid, folded, today = todayKey()) =>
  setDoc(doc(db, "users", uid, "days", today), { remindersFoldedOn: folded ? today : null }, { merge: true });
